import { Routes, Route, Navigate } from 'react-router-dom';
import { Navigation } from './components/Navigation';
import { Home } from './pages/Home';
import { Lineup } from './pages/Lineup';
import { Favorites } from './pages/Favorites';
import { Settings } from './pages/Settings';
import { Map } from './pages/Map';
import { NotificationManager } from './components/NotificationManager';
import { InstallPrompt } from './components/InstallPrompt';
import { OfflineTip } from './components/OfflineTip';
import { useAnalytics } from './hooks/useAnalytics';

function App() {
  useAnalytics();

  return (
    <>
      <div className="bg-background min-h-screen text-text">
        <OfflineTip />
        <NotificationManager />
        <InstallPrompt />
        <Routes>
          <Route path="/index.html" element={<Navigate to="/" replace />} />
          <Route path="/" element={<Home />} />
          <Route path="/lineup" element={<Lineup />} />
          <Route path="/favorites" element={<Favorites />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/map" element={<Map />} />
          <Route path="/schedule" element={<Lineup />} /> {/* Redirect for simplicity */}
        </Routes>
        <Navigation />
      </div>
    </>
  );
}

export default App;
